// Generated by node tools/idle-reach.mjs. Do not edit.
// Body + stage props, excluding the particle layer. Bounds in companion pixels.
// Source SHA-256: 106381b30ef6d1180b53f20fcbee09f110783222384092f7641c080341e28d3f
export const IDLE_REACH = {
  "bit": {
    "minibits": {
      "up": 31,
      "left": 33,
      "right": 33,
      "solo": false,
      "local": true
    },
    "colorcycle": {
      "up": 17,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    },
    "lowres": {
      "up": 15,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    },
    "poppixel": {
      "up": 17,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    }
  },
  "spark": {
    "twinkle": {
      "up": 25,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "constellation": {
      "up": 39,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    },
    "rainbowribbon": {
      "up": 31,
      "left": 24,
      "right": 24,
      "solo": false,
      "local": true
    },
    "wish": {
      "up": 21,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    }
  },
  "robot": {
    "scanbeam": {
      "up": 34,
      "left": 47,
      "right": 47,
      "solo": false,
      "local": true
    },
    "sweepup": {
      "up": 20,
      "left": 37,
      "right": 37,
      "solo": false,
      "local": true
    },
    "beeptune": {
      "up": 21,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "oilcan": {
      "up": 34,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "lowbattery": {
      "up": 19,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "bitride": {
      "up": 19,
      "left": 12,
      "right": 12,
      "solo": true,
      "local": true
    }
  },
  "byte": {
    "bincount": {
      "up": 30,
      "left": 24,
      "right": 24,
      "solo": false,
      "local": true
    },
    "shiftwiggle": {
      "up": 18,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "binaryhi": {
      "up": 32,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "poppixel": {
      "up": 19,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "ninthbit": {
      "up": 15,
      "left": 15,
      "right": 15,
      "solo": true,
      "local": true
    }
  },
  "cursor": {
    "handwave": {
      "up": 21,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "ibeam": {
      "up": 21,
      "left": 57,
      "right": 57,
      "solo": false,
      "local": true
    },
    "resize": {
      "up": 28,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "clickfriend": {
      "up": 21,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": true
    }
  },
  "bat": {
    "dangle": {
      "up": 18,
      "left": 8,
      "right": 8,
      "solo": true,
      "local": false
    },
    "cloak": {
      "up": 19,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "juicebox": {
      "up": 19,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    },
    "countoff": {
      "up": 43,
      "left": 50,
      "right": 50,
      "solo": true,
      "local": true
    }
  },
  "ghost": {
    "peekaboo": {
      "up": 20,
      "left": 42,
      "right": 42,
      "solo": false,
      "local": true
    },
    "spook": {
      "up": 27,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": false
    },
    "shy": {
      "up": 19,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    },
    "lantern": {
      "up": 34,
      "left": 47,
      "right": 47,
      "solo": false,
      "local": true
    }
  },
  "hamster": {
    "hamsterwheel": {
      "up": 30,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "stuffcheeks": {
      "up": 14,
      "left": 24,
      "right": 24,
      "solo": false,
      "local": true
    },
    "facewash": {
      "up": 14,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    },
    "sharesnack": {
      "up": 13,
      "left": 9,
      "right": 9,
      "solo": true,
      "local": true
    }
  },
  "hedgehog": {
    "snuffle": {
      "up": 17,
      "left": 29,
      "right": 29,
      "solo": false,
      "local": true
    },
    "spinecarry": {
      "up": 51,
      "left": 34,
      "right": 34,
      "solo": false,
      "local": true
    },
    "sharesnack": {
      "up": 17,
      "left": 9,
      "right": 9,
      "solo": true,
      "local": true
    }
  },
  "capybara": {
    "onsen": {
      "up": 61,
      "left": 22,
      "right": 22,
      "solo": true,
      "local": true
    },
    "company": {
      "up": 50,
      "left": 52,
      "right": 52,
      "solo": true,
      "local": true
    },
    "graze": {
      "up": 20,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "nodoff": {
      "up": 20,
      "left": 18,
      "right": 18,
      "solo": true,
      "local": true
    }
  },
  "otter": {
    "shellcrack": {
      "up": 25,
      "left": 33,
      "right": 33,
      "solo": false,
      "local": true
    },
    "pebblejuggle": {
      "up": 30,
      "left": 10,
      "right": 10,
      "solo": true,
      "local": true
    },
    "handhold": {
      "up": 17,
      "left": 16,
      "right": 16,
      "solo": true,
      "local": true
    }
  },
  "baby-dragon": {
    "firesneeze": {
      "up": 27,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "marshmallow": {
      "up": 16,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "hoard": {
      "up": 18,
      "left": 29,
      "right": 29,
      "solo": false,
      "local": true
    },
    "tailchase": {
      "up": 24,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "littleroar": {
      "up": 32,
      "left": 15,
      "right": 15,
      "solo": true,
      "local": true
    }
  },
  "snail": {
    "lettuce": {
      "up": 17,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "rainshower": {
      "up": 33,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": true
    },
    "hitchhike": {
      "up": 31,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": false
    }
  },
  "sloth": {
    "hangabout": {
      "up": 142,
      "left": 18,
      "right": 18,
      "solo": true,
      "local": false
    },
    "leafmunch": {
      "up": 67,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "slowwave": {
      "up": 23,
      "left": 19,
      "right": 19,
      "solo": true,
      "local": true
    },
    "bigyawn": {
      "up": 24,
      "left": 19,
      "right": 19,
      "solo": false,
      "local": true
    },
    "piggyback": {
      "up": 38,
      "left": 19,
      "right": 19,
      "solo": true,
      "local": false
    }
  },
  "santa": {
    "hohoho": {
      "up": 40,
      "left": 22,
      "right": 22,
      "solo": false,
      "local": true
    },
    "present": {
      "up": 32,
      "left": 15,
      "right": 15,
      "solo": true,
      "local": true
    },
    "nicelist": {
      "up": 39,
      "left": 26,
      "right": 26,
      "solo": true,
      "local": true
    },
    "cookies": {
      "up": 25,
      "left": 22,
      "right": 22,
      "solo": false,
      "local": true
    }
  },
  "rudolph": {
    "noseblink": {
      "up": 22,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    },
    "prance": {
      "up": 26,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    },
    "carrot": {
      "up": 22,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "pullsleigh": {
      "up": 22,
      "left": 8,
      "right": 8,
      "solo": true,
      "local": false
    }
  },
  "krampus": {
    "chainrattle": {
      "up": 27,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "krampuslauf": {
      "up": 29,
      "left": 36,
      "right": 36,
      "solo": false,
      "local": true
    },
    "rawr": {
      "up": 45,
      "left": 19,
      "right": 19,
      "solo": false,
      "local": true
    },
    "rounds": {
      "up": 27,
      "left": 20,
      "right": 20,
      "solo": true,
      "local": true
    }
  },
  "elf": {
    "workshop": {
      "up": 90,
      "left": 61,
      "right": 61,
      "solo": false,
      "local": true
    },
    "stringlights": {
      "up": 23,
      "left": 40,
      "right": 40,
      "solo": false,
      "local": true
    },
    "heelclick": {
      "up": 29,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    },
    "helpsanta": {
      "up": 22,
      "left": 10,
      "right": 10,
      "solo": true,
      "local": true
    }
  },
  "easter-bunny": {
    "egghunt": {
      "up": 38,
      "left": 202,
      "right": 202,
      "solo": true,
      "local": false
    },
    "paintegg": {
      "up": 23,
      "left": 33,
      "right": 33,
      "solo": true,
      "local": true
    },
    "binky": {
      "up": 27,
      "left": 13,
      "right": 13,
      "solo": true,
      "local": true
    }
  },
  "snowman": {
    "snowfall": {
      "up": 41,
      "left": 28,
      "right": 28,
      "solo": false,
      "local": true
    },
    "melt": {
      "up": 38,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    },
    "carrotnose": {
      "up": 27,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "snowballfight": {
      "up": 42,
      "left": 16,
      "right": 16,
      "solo": true,
      "local": true
    }
  },
  "leprechaun": {
    "countgold": {
      "up": 26,
      "left": 32,
      "right": 32,
      "solo": true,
      "local": true
    },
    "jig": {
      "up": 32,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "mendshoe": {
      "up": 25,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "clover": {
      "up": 27,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    }
  },
  "gingerbread": {
    "catchme": {
      "up": 48,
      "left": 33,
      "right": 33,
      "solo": true,
      "local": true
    },
    "foxride": {
      "up": 19,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": true
    },
    "mendbite": {
      "up": 20,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    }
  },
  "jack-o-lantern": {
    "carve": {
      "up": 20,
      "left": 13,
      "right": 13,
      "solo": true,
      "local": false
    },
    "gutter": {
      "up": 20,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "batvisit": {
      "up": 61,
      "left": 76,
      "right": 76,
      "solo": false,
      "local": true
    },
    "spookoff": {
      "up": 25,
      "left": 13,
      "right": 13,
      "solo": true,
      "local": false
    }
  },
  "clippy": {
    "assist": {
      "up": 67,
      "left": 34,
      "right": 34,
      "solo": false,
      "local": false
    },
    "brows": {
      "up": 17,
      "left": 6,
      "right": 6,
      "solo": false,
      "local": true
    }
  },
  "recycle-bin": {
    "burp": {
      "up": 22,
      "left": 19,
      "right": 19,
      "solo": false,
      "local": true
    },
    "empty": {
      "up": 23,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    }
  },
  "paint": {
    "paintover": {
      "up": 15,
      "left": 15,
      "right": 15,
      "solo": true,
      "local": true
    },
    "rainbow": {
      "up": 21,
      "left": 21,
      "right": 21,
      "solo": true,
      "local": true
    }
  },
  "spotify": {
    "listen": {
      "up": 16,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    }
  },
  "discord": {
    "ping": {
      "up": 19,
      "left": 11,
      "right": 11,
      "solo": true,
      "local": true
    }
  },
  "clock": {
    "alarm": {
      "up": 16,
      "left": 10,
      "right": 10,
      "solo": true,
      "local": true
    }
  },
  "firefox": {
    "tailchase": {
      "up": 21,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "trackers": {
      "up": 18,
      "left": 34,
      "right": 34,
      "solo": false,
      "local": true
    }
  },
  "vscode": {
    "coding": {
      "up": 35,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    }
  },
  "mail": {
    "letters": {
      "up": 45,
      "left": 55,
      "right": 55,
      "solo": true,
      "local": true
    }
  },
  "duo": {
    "lesson": {
      "up": 26,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "streak": {
      "up": 32,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "greetings": {
      "up": 34,
      "left": 20,
      "right": 20,
      "solo": true,
      "local": true
    },
    "nudge": {
      "up": 29,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    }
  },
  "ferris": {
    "crabrave": {
      "up": 14,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "race": {
      "up": 16,
      "left": 29,
      "right": 29,
      "solo": true,
      "local": true
    }
  },
  "tux": {
    "fish": {
      "up": 17,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    },
    "preen": {
      "up": 16,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    }
  },
  "docker": {
    "spout": {
      "up": 28,
      "left": 23,
      "right": 23,
      "solo": false,
      "local": true
    },
    "ship": {
      "up": 61,
      "left": 12,
      "right": 12,
      "solo": true,
      "local": true
    }
  },
  "gopher": {
    "goroutines": {
      "up": 26,
      "left": 61,
      "right": 61,
      "solo": false,
      "local": true
    },
    "popup": {
      "up": 31,
      "left": 26,
      "right": 26,
      "solo": false,
      "local": true
    }
  },
  "duck": {
    "debug": {
      "up": 35,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": false
    }
  },
  "android": {
    "antennawiggle": {
      "up": 19,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    },
    "update": {
      "up": 35,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "dessert": {
      "up": 19,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "highfive": {
      "up": 19,
      "left": 10,
      "right": 10,
      "solo": true,
      "local": true
    }
  },
  "crewmate": {
    "swipe": {
      "up": 34,
      "left": 36,
      "right": 36,
      "solo": false,
      "local": true
    },
    "wires": {
      "up": 16,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "scan": {
      "up": 36,
      "left": 34,
      "right": 34,
      "solo": false,
      "local": true
    },
    "meeting": {
      "up": 38,
      "left": 35,
      "right": 35,
      "solo": true,
      "local": true
    },
    "pet": {
      "up": 30,
      "left": 33,
      "right": 33,
      "solo": true,
      "local": true
    }
  },
  "pacman": {
    "dots": {
      "up": 18,
      "left": 48,
      "right": 48,
      "solo": false,
      "local": true
    },
    "pellet": {
      "up": 244,
      "left": 49,
      "right": 49,
      "solo": true,
      "local": true
    }
  },
  "blinky": {
    "shadow": {
      "up": 18,
      "left": 8,
      "right": 8,
      "solo": true,
      "local": false
    }
  },
  "mario": {
    "blockbump": {
      "up": 57,
      "left": 68,
      "right": 68,
      "solo": false,
      "local": false
    },
    "superstar": {
      "up": 39,
      "left": 96,
      "right": 96,
      "solo": false,
      "local": true
    },
    "bros": {
      "up": 23,
      "left": 7,
      "right": 7,
      "solo": true,
      "local": true
    }
  },
  "luigi": {
    "boo": {
      "up": 35,
      "left": 32,
      "right": 32,
      "solo": true,
      "local": true
    },
    "blockbump": {
      "up": 61,
      "left": 77,
      "right": 77,
      "solo": false,
      "local": false
    },
    "bros": {
      "up": 38,
      "left": 17,
      "right": 17,
      "solo": true,
      "local": true
    }
  },
  "donkey-kong": {
    "chestpound": {
      "up": 22,
      "left": 31,
      "right": 31,
      "solo": true,
      "local": true
    },
    "banana": {
      "up": 25,
      "left": 27,
      "right": 27,
      "solo": false,
      "local": true
    },
    "bongos": {
      "up": 21,
      "left": 23,
      "right": 23,
      "solo": true,
      "local": true
    },
    "jumpman": {
      "up": 21,
      "left": 84,
      "right": 84,
      "solo": true,
      "local": true
    }
  },
  "kirby": {
    "maximtomato": {
      "up": 39,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    },
    "kirbydance": {
      "up": 20,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    },
    "greet": {
      "up": 33,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "inhalefriend": {
      "up": 16,
      "left": 10,
      "right": 10,
      "solo": true,
      "local": true
    }
  },
  "chrome-dino": {
    "dinogame": {
      "up": 57,
      "left": 86,
      "right": 86,
      "solo": true,
      "local": true
    },
    "nightfall": {
      "up": 42,
      "left": 29,
      "right": 29,
      "solo": false,
      "local": true
    }
  },
  "flappy-bird": {
    "flappygame": {
      "up": 77,
      "left": 79,
      "right": 79,
      "solo": false,
      "local": true
    },
    "titlescreen": {
      "up": 40,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    }
  },
  "neko": {
    "nekowash": {
      "up": 15,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    },
    "nekoscratch": {
      "up": 16,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    },
    "nekoyawn": {
      "up": 16,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    }
  },
  "hello-kitty": {
    "hellowave": {
      "up": 33,
      "left": 16,
      "right": 16,
      "solo": true,
      "local": true
    },
    "applepie": {
      "up": 19,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "toypiano": {
      "up": 19,
      "left": 23,
      "right": 23,
      "solo": false,
      "local": true
    },
    "littlegift": {
      "up": 18,
      "left": 9,
      "right": 9,
      "solo": true,
      "local": true
    },
    "appletall": {
      "up": 42,
      "left": 27,
      "right": 27,
      "solo": true,
      "local": true
    }
  },
  "ares": {
    "whet": {
      "up": 23,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    },
    "polish": {
      "up": 27,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    },
    "warcry": {
      "up": 38,
      "left": 29,
      "right": 29,
      "solo": true,
      "local": true
    },
    "vulture": {
      "up": 208,
      "left": 209,
      "right": 209,
      "solo": false,
      "local": true
    }
  },
  "zeus": {
    "cloudthrone": {
      "up": 34,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    },
    "juggle": {
      "up": 44,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    },
    "rumble": {
      "up": 58,
      "left": 55,
      "right": 55,
      "solo": true,
      "local": true
    },
    "eagle": {
      "up": 87,
      "left": 102,
      "right": 102,
      "solo": true,
      "local": true
    }
  },
  "poseidon": {
    "dolphin": {
      "up": 205,
      "left": 208,
      "right": 208,
      "solo": false,
      "local": true
    },
    "fountain": {
      "up": 28,
      "left": 33,
      "right": 33,
      "solo": false,
      "local": true
    },
    "conch": {
      "up": 41,
      "left": 25,
      "right": 25,
      "solo": true,
      "local": true
    },
    "seastorm": {
      "up": 28,
      "left": 22,
      "right": 22,
      "solo": false,
      "local": true
    }
  },
  "hades": {
    "countsouls": {
      "up": 27,
      "left": 47,
      "right": 47,
      "solo": false,
      "local": true
    },
    "pomegranate": {
      "up": 23,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "wisp": {
      "up": 30,
      "left": 16,
      "right": 16,
      "solo": false,
      "local": true
    },
    "heel": {
      "up": 36,
      "left": 39,
      "right": 39,
      "solo": true,
      "local": true
    }
  },
  "cerberus": {
    "threeminds": {
      "up": 18,
      "left": 19,
      "right": 19,
      "solo": false,
      "local": true
    },
    "bonesquabble": {
      "up": 24,
      "left": 20,
      "right": 20,
      "solo": false,
      "local": true
    },
    "scratch": {
      "up": 19,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "serpenttail": {
      "up": 22,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    },
    "fetch": {
      "up": 24,
      "left": 18,
      "right": 18,
      "solo": true,
      "local": true
    },
    "sitdown": {
      "up": 18,
      "left": 18,
      "right": 18,
      "solo": false,
      "local": true
    }
  },
  "athena": {
    "owl": {
      "up": 110,
      "left": 103,
      "right": 103,
      "solo": false,
      "local": true
    },
    "olivetree": {
      "up": 27,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    },
    "loom": {
      "up": 27,
      "left": 22,
      "right": 22,
      "solo": false,
      "local": true
    },
    "scroll": {
      "up": 201,
      "left": 205,
      "right": 205,
      "solo": false,
      "local": true
    },
    "rivals": {
      "up": 23,
      "left": 22,
      "right": 22,
      "solo": true,
      "local": true
    }
  },
  "artemis": {
    "moonrise": {
      "up": 34,
      "left": 27,
      "right": 27,
      "solo": false,
      "local": true
    },
    "feeddeer": {
      "up": 23,
      "left": 64,
      "right": 64,
      "solo": false,
      "local": true
    },
    "bowstring": {
      "up": 24,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    }
  },
  "aphrodite": {
    "handmirror": {
      "up": 23,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "lovesme": {
      "up": 25,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "doves": {
      "up": 97,
      "left": 90,
      "right": 90,
      "solo": false,
      "local": true
    },
    "goldenapple": {
      "up": 27,
      "left": 15,
      "right": 15,
      "solo": false,
      "local": true
    },
    "sweethearts": {
      "up": 34,
      "left": 12,
      "right": 12,
      "solo": true,
      "local": true
    }
  },
  "persephone": {
    "seasons": {
      "up": 22,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "gatherflowers": {
      "up": 23,
      "left": 15,
      "right": 15,
      "solo": true,
      "local": true
    },
    "bellyrub": {
      "up": 26,
      "left": 44,
      "right": 44,
      "solo": true,
      "local": true
    }
  },
  "bastet": {
    "knead": {
      "up": 23,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    },
    "knockoff": {
      "up": 23,
      "left": 22,
      "right": 22,
      "solo": false,
      "local": true
    },
    "catcourt": {
      "up": 24,
      "left": 83,
      "right": 83,
      "solo": true,
      "local": true
    },
    "sitdown": {
      "up": 23,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    }
  },
  "phoenix": {
    "flamepreen": {
      "up": 20,
      "left": 19,
      "right": 19,
      "solo": false,
      "local": true
    },
    "firesong": {
      "up": 20,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "beacon": {
      "up": 30,
      "left": 21,
      "right": 21,
      "solo": true,
      "local": false
    },
    "phoenixtears": {
      "up": 19,
      "left": 9,
      "right": 9,
      "solo": true,
      "local": false
    }
  },
  "medusa": {
    "reflection": {
      "up": 38,
      "left": 13,
      "right": 13,
      "solo": true,
      "local": true
    },
    "petsnakes": {
      "up": 22,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    },
    "snakesquabble": {
      "up": 22,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    },
    "stonebutterfly": {
      "up": 38,
      "left": 56,
      "right": 56,
      "solo": false,
      "local": true
    }
  },
  "steve": {
    "mine": {
      "up": 16,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    }
  },
  "enderman": {
    "carry": {
      "up": 25,
      "left": 31,
      "right": 31,
      "solo": false,
      "local": true
    }
  },
  "villager": {
    "nod": {
      "up": 20,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    }
  },
  "iron-golem": {
    "poppy": {
      "up": 24,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    }
  },
  "cow": {
    "graze": {
      "up": 19,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    }
  },
  "sheep": {
    "graze": {
      "up": 14,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    }
  },
  "chicken": {
    "egg": {
      "up": 12,
      "left": 6,
      "right": 6,
      "solo": false,
      "local": true
    }
  },
  "dog": {
    "sitdown": {
      "up": 13,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "wag": {
      "up": 13,
      "left": 12,
      "right": 12,
      "solo": false,
      "local": true
    },
    "shake": {
      "up": 14,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    }
  },
  "cat": {
    "sitdown": {
      "up": 13,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "groom": {
      "up": 13,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    },
    "gift": {
      "up": 13,
      "left": 4,
      "right": 4,
      "solo": false,
      "local": true
    }
  },
  "fox": {
    "sitdown": {
      "up": 12,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    },
    "berry": {
      "up": 12,
      "left": 13,
      "right": 13,
      "solo": false,
      "local": true
    }
  },
  "panda": {
    "munch": {
      "up": 18,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    },
    "roll": {
      "up": 31,
      "left": 41,
      "right": 41,
      "solo": false,
      "local": true
    },
    "sneeze": {
      "up": 18,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    }
  },
  "bee": {
    "pollinate": {
      "up": 15,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    }
  },
  "axolotl": {
    "playdead": {
      "up": 19,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    }
  },
  "frog": {
    "croak": {
      "up": 9,
      "left": 7,
      "right": 7,
      "solo": false,
      "local": true
    }
  },
  "allay": {
    "music": {
      "up": 18,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    },
    "collect": {
      "up": 21,
      "left": 27,
      "right": 27,
      "solo": true,
      "local": true
    }
  },
  "slime": {
    "split": {
      "up": 18,
      "left": 23,
      "right": 23,
      "solo": false,
      "local": true
    }
  },
  "piglin": {
    "admire": {
      "up": 18,
      "left": 8,
      "right": 8,
      "solo": false,
      "local": true
    }
  },
  "ghast": {
    "cry": {
      "up": 29,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    }
  },
  "blaze": {
    "flare": {
      "up": 20,
      "left": 10,
      "right": 10,
      "solo": false,
      "local": true
    }
  },
  "shulker": {
    "peek": {
      "up": 23,
      "left": 9,
      "right": 9,
      "solo": false,
      "local": true
    }
  },
  "warden": {
    "sniff": {
      "up": 22,
      "left": 11,
      "right": 11,
      "solo": false,
      "local": true
    }
  },
  "wither": {
    "glance": {
      "up": 26,
      "left": 14,
      "right": 14,
      "solo": false,
      "local": true
    }
  },
  "ender-dragon": {
    "roar": {
      "up": 30,
      "left": 21,
      "right": 21,
      "solo": false,
      "local": true
    }
  }
};
